<template>
  <div id="contenedor-presupuestos-default">
    <v-container fluid>
      <v-card
        class="mb-4"
        flat>
        <v-card-text>
          <titulo-tool-bar titulo="Presupuestos">
            <template v-slot:opciones-derecha>
              <v-menu
                v-model="mostrarMenuExportar"
                :close-on-content-click="false"
                offset-y>
                  <template v-slot:activator="{ on: onMenu }">
                  <v-tooltip top>
                    <template v-slot:activator="{ on: onTooltip }">
                      <v-btn icon
                      v-on="{ ...onMenu, ...onTooltip }">
                    <v-icon> mdi-file-excel </v-icon>
                      </v-btn>
                    </template>
                    <span>Exportar</span>
                  </v-tooltip>
                </template>
                <v-list>
                  <!-- <v-list-item
                  @click="mostrarVentanaExcelPresupuestoEjercicio
                    = !mostrarVentanaExcelPresupuestoEjercicio"
                  link>
                    <v-list-item-icon class="mx-2">
                      <v-icon> mdi-file-excel </v-icon>
                    </v-list-item-icon>
                    <v-list-item-content>
                      <v-list-item-title> Exportar Presupuesto </v-list-item-title>
                    </v-list-item-content>
                  </v-list-item> -->
                  <excel-presupuesto-ejercicio
                  :ejercicio="ejercicio"
                  :presupuestos="getPresupuestos"
                  v-on:cerrar="mostrarVentanaExcelPresupuestoEjercicio
                    = !mostrarVentanaExcelPresupuestoEjercicio">
                  </excel-presupuesto-ejercicio>
                  <!-- <v-list-item
                  @click="mostrarExportarConceptosFavoritosEstimados
                  = !mostrarExportarConceptosFavoritosEstimados"
                  link>
                    <v-list-item-icon class="mx-2">
                      <v-icon> mdi-file-excel </v-icon>
                    </v-list-item-icon>
                    <v-list-item-content>
                      <v-list-item-title> Exportar Modificaciones </v-list-item-title>
                    </v-list-item-content>
                  </v-list-item> -->
                  <excel-presupuesto-rango />
                </v-list>
              </v-menu>
            </template>
          </titulo-tool-bar>
          <tool-bar
            class="mb-4"
            v-model="ejercicio"
            v-on:nuevoPresupuesto="registrarNuevoPresupuesto"
            >
          </tool-bar>
          <!-- <v-row>
            <btn-exportar-ejercicio
              :ejercicio="`${ejercicio}`"
              :presupuestos="getPresupuestos" />
            <btn-exportar-rango />
          </v-row> -->
        </v-card-text>
      </v-card>
      <!-- <pre>{{ getDetalles }}</pre> -->
      <v-row v-if="!$apollo.loading" class="mb-4">
        <v-col cols="6" md="auto">
          <v-card color="blue darken-1" dark flat>
            <v-card-title class="mb-1 pt-2 pb-2">
              {{ getTotalAutorizadoDetalles | currency }}
            </v-card-title>
            <v-card-subtitle class="pb-2">P. Autorizado</v-card-subtitle>
          </v-card>
        </v-col>
        <v-col cols="6" md="auto">
          <v-card
            flat
            :color="getColorTotalModificado"
            dark>
            <v-card-title class="mb-1 pt-2 pb-2">
              {{ getTotalModificado | currency }}
            </v-card-title>
            <v-card-subtitle class="pb-2">
              <span>P. Modificado</span>
            </v-card-subtitle>
          </v-card>
        </v-col>
      </v-row>
      <v-card flat>
        <v-card-text>
          <listado :ejercicio="ejercicio" />
        </v-card-text>
      </v-card>
    </v-container>
    <v-dialog
      v-model="mostrarVentanaRegistrarNuevoPresupuesto"
      width="900">
      <registrar-nuevo-presupuesto
        v-if="mostrarVentanaRegistrarNuevoPresupuesto"
        v-on:cerrar="cerrarRegistrarNuevoPresupuesto">
      </registrar-nuevo-presupuesto>
    </v-dialog>
    <v-dialog
      v-if="estaPresupuesto"
      v-model="mostrarVentanaEditarPresupuesto"
      width="900">
      <editar-presupuesto
        :presupuestoEditar="estaPresupuesto"
        v-on:cerrar="cerrarEditarPresupuesto">
      </editar-presupuesto>
    </v-dialog>
    <v-dialog
      v-if="estaPresupuesto"
      v-model="mostrarVentanaEliminarPresupuesto"
      width="600">
      <eliminar-presupuesto
        :presupuestoEliminar="estaPresupuesto"
        v-on:cerrar="cerrarRemoverPresupuesto">
      </eliminar-presupuesto>
    </v-dialog>
    <!-- <v-dialog
      v-if="mostrarVentanaExcelPresupuestoEjercicio"
      v-model="mostrarVentanaExcelPresupuestoEjercicio"
      width="400">
      <excel-presupuesto-ejercicio
      :ejercicio="ejercicio"
      :presupuestos="getPresupuestos"
      v-on:cerrar="mostrarVentanaExcelPresupuestoEjercicio
        = !mostrarVentanaExcelPresupuestoEjercicio">
      </excel-presupuesto-ejercicio>
    </v-dialog> -->
  </div>
</template>

<script>
import mixPresupuestos from '@/components/administracion/presupuestos/mixPresupuestos';
import TituloToolBar from '@/components/TituloToolBar.vue';
import RegistrarNuevoPresupuesto from '@/components/administracion/presupuestos/Nuevo.vue';
import ExcelPresupuestoEjercicio from '@/components/exportar/exceles/ExcelPresupuestoEjercicio.vue';
import ExcelPresupuestoRango from '@/components/exportar/exceles/ExcelPresupuestoRangoFecha.vue';
import EditarPresupuesto from '@/components/administracion/presupuestos/Editar.vue';
import EliminarPresupuesto from '@/components/administracion/presupuestos/Eliminar.vue';
import eventBus from '@/helpers/eventBus';
import ToolBar from './ToolBar.vue';
import Listado from './listado/Main.vue';

export default {
  name: 'PresupuestosDefault',
  mixins: [mixPresupuestos],
  components: {
    TituloToolBar,
    RegistrarNuevoPresupuesto,
    EditarPresupuesto,
    EliminarPresupuesto,
    ToolBar,
    Listado,
    ExcelPresupuestoEjercicio,
    ExcelPresupuestoRango,
  },
  data() {
    return {
      mostrarMenuExportar: false,
      mostrarVentanaRegistrarNuevoPresupuesto: false,
      mostrarVentanaExcelPresupuestoEjercicio: false,
      mostrarVentanaEditarPresupuesto: false,
      mostrarVentanaEliminarPresupuesto: false,
      estaPresupuesto: null,
      ejercicio: Number(new Date().toISOString().substr(0, 4)),
    };
  },
  mounted() {
    eventBus.$on('editar-presupuesto', (presupuesto) => {
      this.estaPresupuesto = presupuesto;
      this.mostrarVentanaEditarPresupuesto = true;
    });
    eventBus.$on('eliminar-presupuesto', (presupuesto) => {
      this.estaPresupuesto = presupuesto;
      this.mostrarVentanaEliminarPresupuesto = true;
    });
  },
  methods: {
    registrarNuevoPresupuesto() {
      this.mostrarVentanaRegistrarNuevoPresupuesto = true;
    },
    cerrarRegistrarNuevoPresupuesto() {
      this.mostrarVentanaRegistrarNuevoPresupuesto = false;
    },
    cerrarEditarPresupuesto() {
      this.mostrarVentanaEditarPresupuesto = false;
      this.estaPresupuesto = null;
    },
    cerrarRemoverPresupuesto() {
      this.mostrarVentanaEliminarPresupuesto = false;
      this.estaPresupuesto = null;
    },
    getImporteModificado({ detalles }) {
      let total = 0;
      detalles.forEach(({ importe, modificaciones }) => {
        const sumaModificaciones = modificaciones.reduce((acc, elem) => acc + elem.importe, 0);
        const preTotal = importe + sumaModificaciones;
        total += preTotal;
      });
      return total;
    },
    getSumaImporteDetalles({ detalles }) {
      return detalles.reduce((acc, elem) => acc + elem.importe, 0);
    },
  },
  computed: {
    getPresupuestos() {
      if (!this.presupuestos) return [];
      return this.presupuestos.filter((item) => Number(item.ejercicio) === Number(this.ejercicio));
    },
    getTotalAutorizado() {
      return this.getPresupuestos.reduce((acc, elem) => acc + elem.importe, 0);
    },
    getTotalAutorizadoDetalles() {
      let total = 0;
      this.getPresupuestos.forEach((presupuesto) => {
        total += this.getSumaImporteDetalles(presupuesto);
      });
      return total;
    },
    getTotalModificado() {
      let total = 0;
      this.getPresupuestos.forEach((presupuesto) => {
        total += this.getImporteModificado(presupuesto);
      });
      return total;
    },
    getColorTotalModificado() {
      return this.getTotalAutorizadoDetalles === this.getTotalModificado ? 'success' : 'warning';
    },
  },
};
</script>

<style lang="scss">

</style>
